import { LOCALE } from "core/interfaces";

import type { KindTrimmed } from "~/common/interfaces/kind-trimmed";

export const getKindId = (kindName: string, kinds: KindTrimmed[] = []) => {
	const kind = kinds.find((kind) => {
		const defaultTranslation = kind.translations?.find(
			translation => translation.locale === LOCALE.ENGLISH
		);

		return (
			kindName.toLowerCase() === defaultTranslation?.namePlural.toLowerCase()
		);
	});

	return kind?.id;
};
